import React, { Component } from 'react';
import Pagination from '@inspinia-react/pagination'
import { notification } from 'antd';

import { get, api, consts, post, del } from '@config'
import { Button, Modal } from 'react-bootstrap';

import { formatDoc, formatPhoneNumber } from "@inspinia-react/utils"
 
import CertificateInfo from '../../fiscal/digital-certificate/components/digital-certificate-info'
import UploadDigitalCertificate from '../../fiscal/digital-certificate/upload-certificate'
import CreateClientModal from '../../clients/create/modal-create'


class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showCert: false,
            certificates: [],
            register: false,
            file: null,
            pwd: "",
            branch_id: "",
            branches: [],

            msgCertificate: "",
            msgCertificateType: ""
        }
        this.onUpload = this.onUpload.bind(this)
        this.onChangePwd = this.onChangePwd.bind(this)
    }


    onUpload(file) { this.setState({ file }) }
    onChangePwd(pwd) { this.setState({ pwd }) }

    getCertificates(branch_id = null) {
        if (!branch_id) {
            branch_id = this.state.branch_id
        }
        const url = `${api.certificates}?branch_owner=${branch_id}`;
        const payload = certificates => {

            this.setState({ certificates });
        };
        const errorPayload = err => {
        }
        get(url, payload, errorPayload);
    }

    setMsg(type, method) {
        let msgOk = "", msgErr = ""
        if (method == "post") {
            msgOk = "Certificado cadastrado com sucesso!"
            msgErr = "Erro ao cadastrar o certificado, verifique os dados e tente novamente!"
        } else if (method == "del") {
            msgOk = "Certificado excluido com sucesso!"
            msgErr = "Erro ao excluir o certificado, verifique os dados e tente novamente!!"
        }
        if (type == "danger") {
            this.setState({ msgCertificate: msgErr, msgCertificateType: type })
        }
        if (type == "success") {
            this.setState({ msgCertificate: msgOk, msgCertificateType: type })
        }
        this.getCertificates()
    }

    body() {
        if (!this.state.register) {
            if (this.state.certificates.length) {
                return <CertificateInfo
                    onDelete={id => {
                        console.log(id)
                        const payload = resp => {
                            this.setMsg("success", "del")
                        }
                        const errPayload = err => {
                            this.setMsg("danger", "del")
                        }
                        del(`${api.certificates}${id}/?branch_owner=${this.state.branch_id}`, payload, errPayload)

                    }}
                    certificates={this.state.certificates}
                />
            }
            return <h3 className='text-center'>Sem certificado cadastrado</h3>
        }
        return <div>
            <UploadDigitalCertificate onUpload={this.onUpload} onChangePassword={this.onChangePwd} />
            <Button variant='primary' onClick={() => this.uploadCert()} >Cadastrar</Button>
        </div>
    }
 

    getBranches() {
        const payload = resp => {
            this.setState({ branches: resp })
        }
        get(api.branches, payload)
    }
    deativateClient(id) {
        const url = `${api.branches}${id}/`
        const payload = resp => {
            console.log(resp)
            this.getBranches() 
            notification.open({
                message: "Cliente desativado com successo",
                type: "success",
                key: 99,
                duration: 3
            })

            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
        const errPayload = err => {
            notification.open({
                message: "Erro ao desativar cliente",
                type: "error",
                key: 99,
                duration: 3
            })
        }

        del(url, payload, errPayload)
    }

    uploadCert(branch_id=null, cert=null) {
        const formData = new FormData();
        cert = cert? cert: {file: this.state.file, pwd: this.state.pwd}
        branch_id = branch_id? branch_id: this.state.branch_id
        
        formData.append("branch_owner", branch_id);
        formData.append("password", cert.pwd);
        formData.append("file", cert.file);
        const url = `${api.certificates}?branch_owner=${branch_id}`;

        function payload(resp) {
            console.log(resp)
            notification.open({
                message: "Cliente cadastrado com sucesso!",
                type: "success",
                key: 2,
                duration: 3
            })
            setTimeout(() => {
                window.location.href = '/accountant/clients/list'
            }, 3000);
        }
        function errPayload(err) {
            console.log(err)
            notification.open({
                message: "Erro ao cadastrar",
                description: "Verifique os dados e tente novamente.",
                type: "error",
                key: 2,
                duration: 3
            })
        }

        post(url, formData, payload, errPayload);

    }
    create(data, cert) {

        const branchPayload = (resp) => {
            this.uploadCert(resp.id, cert)
        }
        const branchErrPayload = (err) => {
            console.log(err)
        }

        post(api.branches, data, branchPayload, branchErrPayload)
    }

    UNSAFE_componentWillMount() {
        this.getBranches()
    }

    render() {
        return (
            <div>
                <h2 className=''>Clientes </h2>
                <CreateClientModal
                    icon mei crt hasCertificate
                    createBranch={(data, cert) => {
                        console.log(data, cert)
                        this.create(data, cert)
                    }}
                />
                <div className="row">

                </div>

                <Pagination
                    labels={[
                        "Nome",
                        "CPF/CNPJ",
                        "Telefone",
                        "Certificado(s)",
                        "Ações"
                    ]}
                    items={this.state.branches}
                    dataComponent={(client) => {
                        return [
                            <td key='1'>
                                {client.name}
                            </td>,
                            <td key='2'>
                                {client.individual ? 
                                formatDoc(client.individual.cpf) : 
                                client.company ? formatDoc(client.company.cnpj) : "N/A"}
                            </td>,
                            <td key='3'>
                                {formatPhoneNumber(client.phone_number)}
                            </td>,
                            <td key='4'>
                                <Button
                                    disabled={!client.is_active}
                                    size='sm' variant='primary'
                                    onClick={_ => {
                                        this.setState({ branch_id: client.id })
                                        this.getCertificates(client.id)
                                        this.setState({ showCert: true })
                                    }}
                                >Detalhes</Button>
                            </td>,
                            <td key='5'>
                                {client.is_active ? [
                                    <i key='21' title='Editar' className='fas fa-edit btn btn-primary mr-3' onClick={() => window.location.href = "/accountant/client/" + client.id} />,
                                    <i key='12' title='Desativar' className='fas fa-ban btn btn-danger' onClick={() => this.setState({ showSure: true, branch_id: client.id })} />
                                ]
                                    : <h4 className='text-danger' >Desativado</h4>}
                            </td>

                        ]
                    }}
                />



                <Modal show={this.state.showSure} >
                    <Modal.Header>Desativar Cliente</Modal.Header>
                    <Modal.Body>
                        <h3>Tem realmente certeza que deseja desativar este cliente?</h3>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showSure: false, branch_id: "" })}>Voltar</Button>
                        <Button
                            variant='danger'
                            onClick={() => {
                                this.deativateClient(this.state.branch_id)
                                this.setState({ showSure: false, branch_id: "" })
                            }}
                        >Sim</Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showCert}>
                    <Modal.Header><h1 className='text-center'>Certificado(s)</h1></Modal.Header>
                    <Modal.Body>
                        {this.state.msgCertificate ?
                            <ul className={`text-${this.state.msgCertificateType}`} >
                                <li>{this.state.msgCertificate}</li>
                            </ul>
                            : <div />}
                        {this.body()}
                    </Modal.Body>
                    <Modal.Footer>
                        {this.state.register ? <div>
                            <Button variant='danger' onClick={_ => this.setState({ register: false })}>Voltar</Button>,
                        </div> : [
                                <Button key='23' variant='danger' onClick={_ => this.setState({ showCert: false, branch_id: "", msgCertificate: "", msgCertificateType: "" })}>Voltar</Button>,
                                <Button key='32' onClick={_ => this.setState({ register: true })}>Cadastrar</Button>
                            ]
                        }
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/pages/accountant/list/index.jsx